/* MBB Homepage v8 — interactions
   Filter pills, hero marquee (WAAPI smooth pause), Voir plus, sticky CTA, exit intent, testimonials columns
   Loaded via <script src="..." defer> from snippets/mbb-homepage.liquid
*/
(function() {
  /* --- Scroll Reveal --- */
  var els = document.querySelectorAll('.mbb-reveal');
  if (els.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) { obs.observe(el); });
  } else { els.forEach(function(el) { el.classList.add('is-visible'); }); }

  /* --- Box filter system (multi-tag, dynamic counts, Voir plus) --- */
  var grid = document.getElementById('mbb-box-grid');
  var pills = Array.prototype.slice.call(document.querySelectorAll('.mbb-pill'));
  var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.mbb-box-card')) : [];
  var dotsEl = document.getElementById('mbb-carousel-dots');
  var showMoreBtn = document.getElementById('mbb-show-more');
  var showMoreCount = document.getElementById('mbb-show-more-count');
  var seeAllLink = document.querySelector('.mbb-bestsellers__see-all');
  var DEFAULT_LIMIT = grid ? parseInt(grid.getAttribute('data-default-limit') || '9', 10) : 9;
  var state = { filter: 'all', expanded: false };

  function cardTags(card) { return (card.getAttribute('data-tags') || '').toLowerCase().split(/\s+/).filter(Boolean); }
  function cardMatches(card, filter) { return filter === 'all' || cardTags(card).indexOf(filter) !== -1; }

  /* Populate pill counts */
  document.querySelectorAll('.mbb-pill__count').forEach(function(el) {
    var key = el.getAttribute('data-count');
    var n = key === 'all' ? cards.length : cards.filter(function(c) { return cardMatches(c, key); }).length;
    el.textContent = '(' + n + ')';
  });

  function renderDots(visibleCards) {
    if (!dotsEl) return;
    dotsEl.innerHTML = '';
    if (window.innerWidth >= 768) return;
    if (visibleCards.length < 2 || visibleCards.length > 8) return;
    visibleCards.forEach(function(_, i) {
      var dot = document.createElement('span');
      dot.className = 'mbb-dot' + (i === 0 ? ' mbb-dot--active' : '');
      dotsEl.appendChild(dot);
    });
    if ('IntersectionObserver' in window) {
      var dotObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var idx = visibleCards.indexOf(entry.target);
            dotsEl.querySelectorAll('.mbb-dot').forEach(function(d, j) {
              d.classList.toggle('mbb-dot--active', j === idx);
            });
          }
        });
      }, { root: grid, threshold: 0.6 });
      visibleCards.forEach(function(c) { dotObserver.observe(c); });
    }
  }

  function applyState() {
    var matching = cards.filter(function(c) { return cardMatches(c, state.filter); });
    var capped = state.filter === 'all' && !state.expanded;
    var visibleCount = 0;
    cards.forEach(function(card) {
      var match = cardMatches(card, state.filter);
      var idxInMatching = matching.indexOf(card);
      var withinCap = capped ? idxInMatching > -1 && idxInMatching < DEFAULT_LIMIT : true;
      var visible = match && withinCap;
      card.classList.toggle('is-hidden', !visible);
      if (visible) visibleCount++;
    });

    var hidden = capped ? Math.max(0, matching.length - DEFAULT_LIMIT) : 0;
    if (showMoreBtn) {
      if (hidden > 0) {
        showMoreBtn.hidden = false;
        if (showMoreCount) showMoreCount.textContent = '(+' + hidden + ')';
      } else {
        showMoreBtn.hidden = true;
      }
    }
    if (seeAllLink) seeAllLink.hidden = false;

    renderDots(cards.filter(function(c) { return !c.classList.contains('is-hidden'); }));
  }

  pills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      pills.forEach(function(p) { p.classList.remove('mbb-pill--active'); });
      pill.classList.add('mbb-pill--active');
      state.filter = pill.getAttribute('data-filter') || 'all';
      state.expanded = false;
      applyState();
      if (grid) grid.scrollLeft = 0;
    });
  });

  if (showMoreBtn) {
    showMoreBtn.addEventListener('click', function() {
      state.expanded = true;
      applyState();
    });
  }

  applyState();

  /* --- Hero marquee: smooth pause --- */
  var track = document.querySelector('.mbb-hero__track');
  var marquee = track && track.closest('.mbb-hero__marquee');
  if (track && marquee && track.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var hero = track.closest('.mbb-hero');
    var durationSeconds = hero ? parseFloat(window.getComputedStyle(hero).getPropertyValue('--mbb-marquee-duration')) : 80;
    var durationMs = (durationSeconds || 80) * 1000;
    track.classList.add('mbb-hero__track--js');
    var marqueeAnimation = track.animate(
      [{ transform: 'translateX(0)' }, { transform: 'translateX(-50%)' }],
      { duration: durationMs, iterations: Infinity, easing: 'linear' }
    );
    var target = 1;
    var current = 1;
    var marqueeFrame = 0;

    function updateMarqueeSpeed() {
      var difference = target - current;
      if (Math.abs(difference) < 0.005) {
        current = target;
        marqueeAnimation.playbackRate = current;
        marqueeFrame = 0;
        return;
      }
      current += difference * 0.08;
      marqueeAnimation.playbackRate = current;
      marqueeFrame = window.requestAnimationFrame(updateMarqueeSpeed);
    }

    function setMarqueeTarget(nextTarget) {
      target = nextTarget;
      if (!marqueeFrame && current !== target) {
        marqueeFrame = window.requestAnimationFrame(updateMarqueeSpeed);
      }
    }

    marquee.addEventListener('mouseenter', function() { setMarqueeTarget(0); });
    marquee.addEventListener('focusin', function() { setMarqueeTarget(0); });
    marquee.addEventListener('mouseleave', function() { setMarqueeTarget(1); });
    marquee.addEventListener('focusout', function() { setMarqueeTarget(1); });
    marquee.addEventListener('touchstart', function() { setMarqueeTarget(0); }, { passive: true });
    marquee.addEventListener('touchend', function() { setMarqueeTarget(1); }, { passive: true });
    marquee.addEventListener('touchcancel', function() { setMarqueeTarget(1); }, { passive: true });
  }

  /* --- Sticky CTA mobile --- */
  var stickyCta = document.getElementById('mbb-sticky-cta');
  if (stickyCta) {
    window.addEventListener('scroll', function() {
      var show = window.scrollY > 400 && (window.scrollY + window.innerHeight < document.body.offsetHeight - 200);
      stickyCta.classList.toggle('is-visible', show);
    });
  }

  /* --- Exit Intent --- */
  var exitModal = document.getElementById('mbb-exit-modal');
  if (exitModal && !sessionStorage.getItem('mbb_exit_shown')) {
    var triggered = false;
    // Desktop: mouse leave
    document.addEventListener('mouseleave', function(e) {
      if (e.clientY <= 5 && !triggered) { showExit(); }
    });
    // Mobile: 80% scroll depth
    window.addEventListener('scroll', function() {
      if (triggered) return;
      var scrollPct = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
      if (scrollPct > 0.8) { showExit(); }
    });
    function showExit() {
      triggered = true;
      sessionStorage.setItem('mbb_exit_shown', '1');
      exitModal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }
    document.getElementById('mbb-exit-close').addEventListener('click', closeExit);
    document.getElementById('mbb-exit-backdrop').addEventListener('click', closeExit);
    function closeExit() {
      exitModal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }
    // Copy code
    document.getElementById('mbb-copy-btn').addEventListener('click', function() {
      navigator.clipboard.writeText('BIENVENUE10').then(function() {
        document.getElementById('mbb-copy-btn').textContent = 'Copié !';
      });
    });
  }

  /* --- Testimonials columns --- */
  var testimonialColumns = document.querySelector('[data-testimonials]');
  if (testimonialColumns) {
    var testimonialReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

    function stripShopifyAttributes(element) {
      var elements = [element].concat(Array.prototype.slice.call(element.querySelectorAll('*')));
      elements.forEach(function(node) {
        Array.prototype.slice.call(node.attributes).forEach(function(attribute) {
          if (attribute.name.indexOf('data-shopify-') === 0) node.removeAttribute(attribute.name);
        });
      });
    }

    function fillTestimonialTracks() {
      if (testimonialReducedMotion && testimonialReducedMotion.matches) return;

      testimonialColumns.querySelectorAll('.mbb-testimonials__track').forEach(function(track) {
        var column = track.parentElement;
        if (!column || column.offsetParent === null || window.getComputedStyle(column).display === 'none') return;
        if (track.hasAttribute('data-testimonials-filled')) {
          if (track.scrollHeight >= 2 * testimonialColumns.clientHeight) return;
          track.removeAttribute('data-testimonials-filled');
        }

        var originalCards = Array.prototype.slice.call(track.children).filter(function(child) {
          return child.getAttribute('aria-hidden') !== 'true';
        });
        var passCount = originalCards.length ? track.children.length / originalCards.length : 0;
        var extraPairs = Math.max(0, Math.floor((passCount - 2) / 2));

        while (track.scrollHeight < 2 * testimonialColumns.clientHeight && extraPairs < 4 && originalCards.length) {
          for (var pass = 0; pass < 2; pass++) {
            originalCards.forEach(function(child) {
              var clone = child.cloneNode(true);
              clone.setAttribute('aria-hidden', 'true');
              stripShopifyAttributes(clone);
              track.appendChild(clone);
            });
          }
          extraPairs++;
        }

        if (track.scrollHeight >= 2 * testimonialColumns.clientHeight) {
          track.setAttribute('data-testimonials-filled', 'true');
        }
      });
    }

    var testimonialResizeTimer;
    window.addEventListener('resize', function() {
      window.clearTimeout(testimonialResizeTimer);
      testimonialResizeTimer = window.setTimeout(fillTestimonialTracks, 200);
    });
    fillTestimonialTracks();
  }
})();
